/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSystemFeatureStatusViewModel } from '../../models/client-system-feature-status-view-model';

export interface GetClientSystemFeatureStatuses$Params {
  clientID: number;
}

export function GetClientSystemFeatureStatuses(http: HttpClient, rootUrl: string, params: GetClientSystemFeatureStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSystemFeatureStatusViewModel>>> {
  const rb = new RequestBuilder(rootUrl, GetClientSystemFeatureStatuses.PATH, 'post');
  if (params) {
    rb.path('clientID', params.clientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientSystemFeatureStatusViewModel>>;
    })
  );
}

GetClientSystemFeatureStatuses.PATH = '/api/Clients/GetClientSystemFeatureStatuses/{clientID}';
